import { API_URL, MOKA_INVENTORY_API } from '../constants';

export const V1_URL = `${API_URL}/v1/ingredients_inventory`;

export const V1_SUMMARY = `${MOKA_INVENTORY_API}/v1/inventory/summary-ingredient`;

export const V1_SUPPLIER_BY_ID = (id) => `${V1_URL}/suppliers/${id}`;

export const V1_SUPPLIER = `${V1_URL}/suppliers`;

export const V1_EXPORT_SUMMARY = `${MOKA_INVENTORY_API}/v1/inventory/summary-ingredient/export`;

export const V1_ADJUSTMENTS = `${V1_URL}/adjustment`;

export const V1_ADJUSTMENTS_NEW = `${MOKA_INVENTORY_API}/v1/ingredient-adjustment`;

export const V1_EXPORT_SUPPLIER = `${V1_URL}/suppliers/export`;

export const V1_EXPORT_ADJUSTMENT = `${V1_URL}/adjustment/export`;
